export enum ItemId {
	District = 'District',
	PersonalInformation = 'PersonalInformation',
	MarkingPeriods = 'MarkingPeriods',
	Login = 'Login',
}
